export const LOBBY_PHASE = Object.freeze({
  BETTING: 'betting',
  SHUFFLING: 'shuffling',
  CLOSED: 'closed',
  MAINTENANCE: 'maintenance'
});

const CHINA_UTC_OFFSET_MS = 8 * 60 * 60 * 1000;
const MAINTENANCE_START_MINUTE = 7 * 60 + 50;
const MAINTENANCE_END_MINUTE = 8 * 60 + 15;

export function chinaMinutesOfDay(nowMs) {
  if (typeof nowMs !== 'number' || !Number.isFinite(nowMs)) return NaN;
  const chinaTime = new Date(Number(nowMs) + CHINA_UTC_OFFSET_MS);
  return chinaTime.getUTCHours() * 60 + chinaTime.getUTCMinutes();
}

export function isLobbyMaintenanceTime(nowMs) {
  const minute = chinaMinutesOfDay(nowMs);
  return minute >= MAINTENANCE_START_MINUTE && minute < MAINTENANCE_END_MINUTE;
}

export function isLobbyRoadEmpty(table, roadRecord) {
  if (typeof table?.LastBootRoads === 'string') return table.LastBootRoads.trim() === '';
  // Binary road frames belong to a specific shoe. An old frame or a frame
  // still awaiting resync cannot prove the current shoe is empty.
  return table?.LastBootID !== undefined && table?.LastBootID !== null
    && String(table.LastBootID) === roadRecord?.bootId
    && roadRecord?.total === 0 && roadRecord?.codes?.length === 0;
}

export function deriveLobbyPhase({ countdown = 0, lastSetNum, roadEmpty = false, nowMs = null } = {}) {
  if (isLobbyMaintenanceTime(nowMs)) return LOBBY_PHASE.MAINTENANCE;
  if (Number(countdown) > 0) return LOBBY_PHASE.BETTING;
  const roundKnown = (typeof lastSetNum === 'number' || typeof lastSetNum === 'string')
    && String(lastSetNum).trim() !== '' && Number.isFinite(Number(lastSetNum));
  if (roundKnown && Number(lastSetNum) === 0 && roadEmpty === true) return LOBBY_PHASE.SHUFFLING;
  return LOBBY_PHASE.CLOSED;
}
